import { memo, type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
}

const PADDING_CLASSES = {
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
} as const;

export const Card = memo(function Card({
  children,
  className,
  padding = 'md',
}: CardProps): React.ReactElement {
  return (
    <div
      className={cn(
        'rounded-care-lg bg-care-surface shadow-card',
        PADDING_CLASSES[padding],
        className,
      )}
    >
      {children}
    </div>
  );
});
